import React, { useState } from "react"
import * as Icon from "react-feather"
import Modal from "react-modal"
import Image from 'gatsby-image';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

const customStyles = {
    content: {
        top: 0,
        left: 0,
        overflow: "auto",
        borderRadius: "4px",
        position: "relative",
        width: "auto",
        display: "flex",
        alignItems: " center",
        minHeight: "calc(100% - (.5rem * 2))",
        margin: "1.75rem auto",
        outline: "none"
    },
}

const Portafolio = ({ content }) => {

    const { titulo, categoria, link, imagen, categorias, descripcion, date, industria } = content

    const [modalIsOpen, setIsOpen] = useState(false)

    const openModal = () => {
        setIsOpen(true)
    }

    const closeModal = () => {
        setIsOpen(false)
    }

    return (
        <div className="mi-portfolio mi-portfolio-visible">
            <div className="mi-portfolio-image">
                <Image
                    fluid={imagen.fluid}
                />
                <ul>
                    <li>
                        <button onClick={openModal}>
                            <Icon.ZoomIn />
                        </button>
                    </li>
                    <li>
                        <OutboundLink rel="noopener noreferrer" target="_blank" href={link ? link : "https://www.instagram.com/pabl0dev/"}>
                            <Icon.Link />
                        </OutboundLink>
                    </li>
                </ul>
            </div>
            <p className="h5">
                <OutboundLink rel="noopener noreferrer" href={link ? link : "https://www.instagram.com/pabl0dev/"} target="_blank">{titulo}</OutboundLink>
            </p>
            <p className="h6">{categoria}</p>
            <div>
                <Modal
                closeTimeoutMS={300}
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal" 
                ariaHideApp={false}
                bodyOpenClassName={"ReactModal__Body--open"}
                className={'container'}
                >
                    <div className="modal-content p-4">
                        <div className="container">
                            <h2 className="text-6 font-weight-600 text-center mb-4">{titulo}</h2>
                            <div className="row">
                                <div className="col-sm-7">
                                    <Image
                                        fluid={imagen.fluid}
                                    />
                                </div>
                                <div className="col-sm-5">
                                    <h6 className="font-weight-600">Project info</h6>
                                    <p>{descripcion}</p>
                                    <h6 className="font-weight-600">Project Details:</h6>
                                    <ul className="list-style-2">
                                        <li className=""><span className="text-dark font-weight-600 mr-2">Industry:</span>{industria}</li>
                                        <li className=""><span className="text-dark font-weight-600 mr-2">Technologies:</span>{categorias}</li>
                                        <li className=""><span className="text-dark font-weight-600 mr-2">Date:</span>{date}</li>
                                        <li className=""><span className="text-dark font-weight-600 mr-2">URL:</span><OutboundLink rel="noopener noreferrer" href={link ? link : "https://www.instagram.com/pabl0dev/"} target="_blank">{link}</OutboundLink></li>
                                    </ul>
                                </div>
                            </div>
                            <button onClick={closeModal} type="button" className="mfp-close">×</button>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}

export default Portafolio
